import React from 'react';

export function PurchaseButton({ loading, onClick }) {
    const handleClick = () => {
        console.log('PurchaseButton нажат'); // Добавляем лог
        if (onClick && !loading) {
            onClick();
        }
    };

    return (
        <div className="btn btn-green" onClick={handleClick}>
            <div className="v1_130">
                {loading ? 'Обработка...' : 'Купить'}
            </div>
        </div>
    );
}